import { React, useState, useEffect, useRef } from "react";
import ReactMarkdown from "react-markdown";
import {
  IconButton,
  Avatar,
  CircularProgress,
  Drawer,
  List,
  ListItem,
  ListItemText,
  TextField,
  Select,
  MenuItem,
  ListItemIcon,
  TextareaAutosize,
} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import SendIcon from "@mui/icons-material/Send";
import LogoutIcon from "@mui/icons-material/Logout";
import DeleteIcon from "@mui/icons-material/Delete";
import { FiMenu, FiRefreshCcw, FiX } from "react-icons/fi";
import Button from "./components/Button";
import { toast } from "react-toastify";
import Spinner from "./components/Spinner";
import { useNavigate } from "react-router-dom";
import { MdHelpOutline, MdRestartAlt } from "react-icons/md";
import { CgProfile } from "react-icons/cg";
import {
  SelectedFilePreview,
  UploadButton,
  useFileUpload,
} from "./features/file_upload/FileUploadUpdated";
import FileManager from "./features/file-operations/FileManager";
import { GrAttachment } from "react-icons/gr";
import Swal from "sweetalert2";
import { wrap } from "framer-motion";

const backend_url = process.env.REACT_APP_BACKEND_SERVICE_URL;
//const backend_url = "https://datagenx-backend-srv-801923314065.europe-west3.run.app";

function ChatbotPage({ userName, userId, onLogout }) {
  const copilotPlatforms = [
    { label: "Fivetran", showPreview: false },
    { label: "HVR6", showPreview: true },
    { label: "dbt labs", showPreview: true },
    { label: "Informatica", showPreview: true },
    { label: "Airbyte", showPreview: true },
  ];

  const isDesktopSidebar = useMediaQuery("(min-width: 1024px)");
  const mainRef = useRef(null);
  const [isLoadingProfile, setIsLoadingProfile] = useState(false);
  const [isUpdatingProfile, setIsUpdatingProfile] = useState(false);
  const [isSavingSecretLoading, setIsSavingSecretLoading] = useState(false);
  const [isLoadingSecrets, setIsLoadingSecrets] = useState(false);

  const [messagesFive, setMessagesFive] = useState([]);
  const [messagesH, setMessagesH] = useState([]);
  const [messagesD, setMessagesD] = useState([]);
  const [messagesInformatica, setMessagesInformatica] = useState([]);
  const [messagesAirbyte, setMessagesAirbyte] = useState([]);

  const [input, setInput] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const [activeView, setActiveView] = useState("chatFive");
  const [profile, setProfile] = useState({
    firstName: "",
    lastName: "",
    jobTitle: "",
    companyName: "",
    password: "",
    confirmPassword: "",
  });
  const [subscriptions, setSubscriptions] = useState([]);
  const [isSubscriptionsLoading, setIsSubscriptionsLoading] = useState(false);
  const [subscriptionType, setSubscriptionType] = useState("Standard");
  const [months, setMonths] = useState(1);
  const [amount, setAmount] = useState(0);
  const [tokens, setTokens] = useState(0);
  const [secrets, setSecrets] = useState([]);
  const [platformType, setPlatformType] = useState("Fivetran");
  const [secretName, setSecretName] = useState("");
  const [secretValue, setSecretValue] = useState("");
  const [isMobileDrawerOpen, setIsMobileDrawerOpen] = useState(false);
  const [selectedSub, setSelectedSub] = useState(null);
  const [selectedSec, setSelectedSec] = useState(null);
  const [newFetchedTokens, setNewFetchedTokens] = useState(null);
  const [isLoadingTokens, setIsLoadingTokens] = useState("not loaded before");
  const [isLoadingReset, setIsLoadingReset] = useState(false);
  const [logOutOpened, setLogOutOpened] = useState(false);
  const [platform, setPlatform] = useState("Fivetran");
  const [activeSubscription, setActiveSubscription] = useState(null);
  const { uploadSelectedFile, removeFile, selectedFile, uploading } =
    useFileUpload();

  const handleClickPlatform = (value) => {
    setPlatform(value);
    if (value === "Fivetran") {
      setActiveView("chatFive");
    } else if (value === "HVR6") {
      setActiveView("chatH");
    } else if (value === "Informatica") {
      setActiveView("chatInformatica");
    } else if (value === "dbt labs") {
      setActiveView("chatD");
    } else if (value === "Airbyte") {
      setActiveView("chatAirbyte");
    }
    handleDrawerClose();
  };

  useEffect(() => {
    if (activeView === "profile") {
      fetchCurrentProfile();
    } else if (activeView === "subscriptions") {
      fetchSubscriptions();
    } else if (activeView === "secrets") {
      fetchSecrets();
    }
  }, [activeView]);

  useEffect(() => {
    // Update tokens and amount based on subscription type
    switch (subscriptionType) {
      case "Standard":
        setTokens(3000000 * (months || 1)); // Tokens are multiplied by months
        setAmount(29 * (months || 1)); // Amount is multiplied by months
        break;
      case "premium":
        setTokens(12000000 * (months || 1)); // Tokens are multiplied by months
        setAmount(99 * (months || 1)); // Amount is multiplied by months
        break;
      case "Professional":
        setTokens(30000000 * (months || 1)); // Tokens are multiplied by months
        setAmount(199 * (months || 1)); // Amount is multiplied by months
        break;
      default:
        setTokens(0);
        setAmount(0);
    }
  }, [subscriptionType, months]);

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      if (event.shiftKey) {
        return;
      }
      event.preventDefault();
      handleSendMessage();
    }
  };

  const [newIsProcessingFive, setNewIsProcessingFive] = useState(false);
  const [newIsStreamingFive, setNewIsStreamingFive] = useState(false);

  const [newIsProcessingH, setNewIsProcessingH] = useState(false);
  const [newIsStreamingH, setNewIsStreamingH] = useState(false);

  const [newIsProcessingInformatica, setNewIsProcessingInformatica] =
    useState(false);
  const [newIsStreamingInformatica, setNewIsStreamingInformatica] =
    useState(false);

  const [newIsProcessingD, setNewIsProcessingD] = useState(false);
  const [newIsStreamingD, setNewIsStreamingD] = useState(false);

  const [newIsProcessingAirbyte, setNewIsProcessingAirbyte] = useState(false);
  const [newIsStreamingAirbyte, setNewIsStreamingAirbyte] = useState(false);

  const handleSendMessage = async () => {
    if (!input.trim()) return;
    if (uploading) return;

    let uploadedFileName = null;
    if (selectedFile) {
      try {
        const uploadResult = await uploadSelectedFile(platform);
        if (uploadResult) {
          uploadedFileName = selectedFile.name;
          removeFile();
        } else {
          return;
        }
      } catch (error) {
        return;
      }
    }

    const userMessage = {
      role: "user",
      content: input,
      fileName: uploadedFileName,
    };
    if (activeView === "chatFive") {
      setMessagesFive((prevMessages) => [...prevMessages, userMessage]);
    } else if (activeView === "chatH") {
      setMessagesH((prevMessages) => [...prevMessages, userMessage]);
    } else if (activeView === "chatInformatica") {
      setMessagesInformatica((prevMessages) => [...prevMessages, userMessage]);
    } else if (activeView === "chatD") {
      setMessagesD((prevMessages) => [...prevMessages, userMessage]);
    } else if (activeView === "chatAirbyte") {
      setMessagesAirbyte((prevMessages) => [...prevMessages, userMessage]);
    }

    setInput("");
    fetchTokens();
    fetchActiveSubscription();

    try {
      setIsTyping(true);

      let assistantMessage = { role: "assistant", content: "" };
      if (activeView === "chatFive") {
        setMessagesFive((prev) => [...prev, assistantMessage]);
      } else if (activeView === "chatH") {
        setMessagesH((prev) => [...prev, assistantMessage]);
      } else if (activeView === "chatInformatica") {
        setMessagesInformatica((prev) => [...prev, assistantMessage]);
      } else if (activeView === "chatD") {
        setMessagesD((prev) => [...prev, assistantMessage]);
      } else if (activeView === "chatAirbyte") {
        setMessagesAirbyte((prev) => [...prev, assistantMessage]);
      }

      if (activeSubscription === "No Active Subscription") {
        toast.error("No active subscription! Please reactivate it.");
        return;
      }

      const source = new EventSource(
        backend_url +
          "/chat?userId=" +
          userId +
          "&message=" +
          encodeURIComponent(input) +
          "&platform=" +
          platform,
      );

      if (activeView === "chatFive") {
        setNewIsProcessingFive(true);
        setNewIsStreamingFive(false);
      } else if (activeView === "chatH") {
        setNewIsProcessingH(true);
        setNewIsStreamingH(false);
      } else if (activeView === "chatInformatica") {
        setNewIsProcessingInformatica(true);
        setNewIsStreamingInformatica(false);
      } else if (activeView === "chatD") {
        setNewIsProcessingD(true);
        setNewIsStreamingD(false);
      } else if (activeView === "chatAirbyte") {
        setNewIsProcessingAirbyte(true);
        setNewIsStreamingAirbyte(false);
      }

      source.addEventListener("message", (event) => {
        try {
          const data = JSON.parse(event.data);

          if (activeView === "chatFive") {
            if (!newIsStreamingFive) {
              setNewIsProcessingFive(false);
              setNewIsStreamingFive(true);
            }
          } else if (activeView === "chatH") {
            if (!newIsStreamingH) {
              setNewIsProcessingH(false);
              setNewIsStreamingH(true);
            }
          } else if (activeView === "chatInformatica") {
            if (!newIsStreamingInformatica) {
              setNewIsProcessingInformatica(false);
              setNewIsStreamingInformatica(true);
            }
          } else if (activeView === "chatD") {
            if (!newIsStreamingD) {
              setNewIsProcessingD(false);
              setNewIsStreamingD(true);
            }
          } else if (activeView === "chatAirbyte") {
            if (!newIsStreamingAirbyte) {
              setNewIsProcessingAirbyte(false);
              setNewIsStreamingAirbyte(true);
            }
          }

          if (data.content) {
            if (activeView === "chatFive") {
              setMessagesFive((prev) => {
                const newMessages = [...prev];
                const lastMessage = newMessages[newMessages.length - 1];
                if (lastMessage.role === "assistant") {
                  lastMessage.content += data.content;
                } else {
                  newMessages.push({
                    role: "assistant",
                    content: data.content,
                  });
                }
                return newMessages;
              });
            } else if (activeView === "chatH") {
              setMessagesH((prev) => {
                const newMessages = [...prev];
                const lastMessage = newMessages[newMessages.length - 1];
                if (lastMessage.role === "assistant") {
                  lastMessage.content += data.content;
                } else {
                  newMessages.push({
                    role: "assistant",
                    content: data.content,
                  });
                }
                return newMessages;
              });
            } else if (activeView === "chatInformatica") {
              setMessagesInformatica((prev) => {
                const newMessages = [...prev];
                const lastMessage = newMessages[newMessages.length - 1];
                if (lastMessage.role === "assistant") {
                  lastMessage.content += data.content;
                } else {
                  newMessages.push({
                    role: "assistant",
                    content: data.content,
                  });
                }
                return newMessages;
              });
            } else if (activeView === "chatD") {
              setMessagesD((prev) => {
                const newMessages = [...prev];
                const lastMessage = newMessages[newMessages.length - 1];
                if (lastMessage.role === "assistant") {
                  lastMessage.content += data.content;
                } else {
                  newMessages.push({
                    role: "assistant",
                    content: data.content,
                  });
                }
                return newMessages;
              });
            } else if (activeView === "chatAirbyte") {
              setMessagesAirbyte((prev) => {
                const newMessages = [...prev];
                const lastMessage = newMessages[newMessages.length - 1];
                if (lastMessage.role === "assistant") {
                  lastMessage.content += data.content;
                } else {
                  newMessages.push({
                    role: "assistant",
                    content: data.content,
                  });
                }
                return newMessages;
              });
            }
          }
        } catch (err) {
          console.error("Error parsing SSE data:", err);
        }
      });

      source.addEventListener("done", () => {
        source.close();
        setIsTyping(false);

        if (activeView === "chatFive") {
          setNewIsStreamingFive(false);
        } else if (activeView === "chatH") {
          setNewIsStreamingH(false);
        } else if (activeView === "chatInformatica") {
          setNewIsStreamingInformatica(false);
        } else if (activeView === "chatD") {
          setNewIsStreamingD(false);
        } else if (activeView === "chatAirbyte") {
          setNewIsStreamingAirbyte(false);
        }
      });

      source.onerror = (err) => {
        toast.error(
          "Something went wrong! Make sure your network is stable, try resetting the chat, or contact DatagenX support!",
          {
            autoClose: false,
            closeOnClick: true,
            draggable: true,
          },
        );
        console.error("Stream error:", err);
        source.close();
        setIsTyping(false);

        if (activeView === "chatFive") {
          setNewIsProcessingFive(false);
          setNewIsStreamingFive(false);
        } else if (activeView === "chatH") {
          setNewIsProcessingH(false);
          setNewIsStreamingH(false);
        } else if (activeView === "chatInformatica") {
          setNewIsProcessingInformatica(false);
          setNewIsStreamingInformatica(false);
        } else if (activeView === "chatD") {
          setNewIsProcessingD(false);
          setNewIsStreamingD(false);
        } else if (activeView === "chatAirbyte") {
          setNewIsProcessingAirbyte(false);
          setNewIsStreamingAirbyte(false);
        }
      };

      return () => {
        source.close();
        setIsTyping(false);

        if (activeView === "chatFive") {
          setNewIsProcessingFive(false);
          setNewIsStreamingFive(false);
        } else if (activeView === "chatH") {
          setNewIsProcessingH(false);
          setNewIsStreamingH(false);
        } else if (activeView === "chatInformatica") {
          setNewIsProcessingInformatica(false);
          setNewIsStreamingInformatica(false);
        } else if (activeView === "chatD") {
          setNewIsProcessingD(false);
          setNewIsStreamingD(false);
        } else if (activeView === "chatAirbyte") {
          setNewIsProcessingAirbyte(false);
          setNewIsStreamingAirbyte(false);
        }
      };
    } catch (error) {
      console.error("Error sending message:", error);
    } finally {
      setIsTyping(false);
    }
  };

  const fetchCurrentProfile = async () => {
    setIsLoadingProfile(true);
    try {
      const response = await fetch(backend_url + "/profile", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId }),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch profile");
      }

      const data = await response.json();

      if (data.success) {
        setProfile({
          firstName: data.firstName,
          lastName: data.lastName,
          jobTitle: data.jobTitle,
          companyName: data.companyName,
          password: "",
          confirmPassword: "",
        });
      } else {
        toast.error(data.error || "Failed to fetch profile");
      }
    } catch (error) {
      console.error("Error fetching profile:", error);
      toast.error("Network or server error while fetching profile");
    } finally {
      setIsLoadingProfile(false);
    }
  };

  const fetchActiveSubscription = async () => {
    try {
      const response = await fetch(
        `${backend_url}/active-subscription?userId=${userId}`,
      );
      const data = await response.json();

      if (data.success) {
        setActiveSubscription(data.subscription);
      } else {
        setActiveSubscription("No Active Subscription");
      }
    } catch (error) {
      console.error("Error fetching active subscription:", error);
    }
  };
  useEffect(() => {
    fetchActiveSubscription();
  }, []);

  const fetchTokens = async () => {
    if (isLoadingTokens === "not loaded before") {
      setIsLoadingTokens("loading for the first time");
    }
    try {
      const response = await fetch(`${backend_url}/tokens?userId=${userId}`);
      const data = await response.json();
      if (data.success) {
        setNewFetchedTokens({
          total: data.totalTokens,
          used: data.usedTokens,
          remaining: data.remainingTokens,
        });
      } else {
        console.error("Error:", data.error);
      }
    } catch (error) {
      console.error("Error fetching tokens:", error);
    } finally {
      setIsLoadingTokens("loaded");
    }
  };
  useEffect(() => {
    fetchTokens();
  }, []);

  const handleReset = async () => {
    setIsLoadingReset(true);
    try {
      const response = await fetch(
        `${backend_url}/reset?userId=${userId}&platform=${platform}`,
        {
          method: "GET",
        },
      );

      const data = await response.json();

      if (data.success) {
        if (activeView === "chatFive") {
          setMessagesFive([]);
        } else if (activeView === "chatH") {
          setMessagesH([]);
        } else if (activeView === "chatInformatica") {
          setMessagesInformatica([]);
        } else if (activeView === "chatD") {
          setMessagesD([]);
        } else if (activeView === "chatAirbyte") {
          setMessagesAirbyte([]);
        }
      } else {
        let errorMessage = data.error;
        if (Array.isArray(data.error)) {
          errorMessage = data.error.join(", ");
        }
        toast.error(errorMessage || "Reset failed!");
      }
    } catch (error) {
      toast.error("Network or server error during reset");
      console.error("Error resetting:", error);
    } finally {
      setIsLoadingReset(false);
      handleDrawerClose();
    }
  };

  const handleUpdateProfile = async () => {
    if (profile.password !== profile.confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    setIsUpdatingProfile(true);

    try {
      const response = await fetch(backend_url + "/update-profile", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId, profile }),
      });

      if (!response.ok) {
        throw new Error("Failed to update profile");
      }

      const data = await response.json();

      if (data.success) {
        toast.success("Profile updated successfully");
      } else {
        toast.error(data.error || "Failed to update profile");
      }
    } catch (error) {
      console.error("Error updating profile:", error);
      toast.error("Network or server error while updating profile");
    } finally {
      setIsUpdatingProfile(false);
    }
  };

  const fetchSubscriptions = async () => {
    setIsSubscriptionsLoading(true);
    try {
      const response = await fetch(backend_url + "/subscriptions", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId }),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch subscriptions");
      }

      const data = await response.json();

      if (data.success) {
        setSubscriptions(data.subscriptions);
      } else {
        toast.error(data.error || "Failed to fetch subscriptions");
      }
    } catch (error) {
      console.error("Error fetching subscriptions:", error);
      toast.error("Network or server error while fetching subscriptions");
    } finally {
      setIsSubscriptionsLoading(false);
    }
  };

  const handleGeneratePayment = async () => {
    Swal.fire({
      title:
        '<div style="font-size: 20px; font-weight: 600;">Please contact support!</div>',
      icon: "info",
      iconColor: "#452ad1",
      html: `
    <div style="display: flex; flex-direction: column; align-items: center; gap: 10px;">
      <div style="display: flex; align-items: center; gap: 10px;">
        <a href="mailto:osama.attia@datagenx.ai" id="support-email" style="text-decoration: none; color: #452ad1 !important; font-weight: 500;">
          osama.attia@datagenx.ai
        </a>
        <button id="copy-btn" title="Copy to clipboard" style="background: none; border: none; cursor: pointer; display: flex; align-items: center;">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" style="margin-top: 3px" viewBox="0 0 24 24" fill="none" stroke="#666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>
        </button>
      </div>
      <span id="copy-status" style="font-size: 12px; color: #28a745; height: 15px; visibility: hidden;">Email copied to clipboard!</span>
    </div>
  `,
      showCloseButton: true,
      showConfirmButton: false,
      didOpen: () => {
        const container = Swal.getContainer();
        if (container) {
          container.style.zIndex = "999999";
        }

        const copyBtn = document.getElementById("copy-btn");
        const statusText = document.getElementById("copy-status");
        const email = "osama.attia@datagenx.ai";

        copyBtn.addEventListener("click", () => {
          navigator.clipboard.writeText(email).then(() => {
            statusText.style.visibility = "visible";
            setTimeout(() => {
              statusText.style.visibility = "hidden";
            }, 5000);
          });
        });
      },
    }); /*
    try {
      const response = await fetch(backend_url + "/payment", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          subscriptionType,
          months,
          amount,
          tokens,
          userId,
        }),
      });
      if (!response.ok) {
        throw new Error("Failed to generate payment URL");
      }

      const data = await response.json();
      window.open(data.paymentUrl, "_blank");
    } catch (error) {
      console.error("Error generating payment URL:", error);
    }
    */
  };

  const fetchSecrets = async () => {
    setIsLoadingSecrets(true);
    try {
      const response = await fetch(backend_url + "/secrets", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId }),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch secrets");
      }

      const data = await response.json();

      if (data.success) {
        setSecrets(data.secrets);
      } else {
        toast.error(data.error || "Failed to fetch secrets");
      }
    } catch (error) {
      console.error("Error fetching secrets:", error);
      toast.error("Network or server error while fetching secrets");
    } finally {
      setIsLoadingSecrets(false);
    }
  };

  const handleSaveSecret = async () => {
    const newSecret = { platformType, secretName, secretValue };
    setIsSavingSecretLoading(true);

    try {
      const response = await fetch(backend_url + "/add-secret", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ platformType, secretName, secretValue, userId }),
      });

      if (!response.ok) {
        throw new Error("Failed to save secret");
      }

      const savedSecret = await response.json();
      setSecrets((prevSecrets) => [...prevSecrets, savedSecret]);
      await fetchSecrets();
      setSecretName("");
      setSecretValue("");
    } catch (error) {
      console.error("Error saving secret:", error);
      toast.error("Error saving secret");
    } finally {
      setIsSavingSecretLoading(false);
    }
  };

  const handleDeleteSecret = async (index) => {
    const secretToDelete = secrets[index];

    try {
      const response = await fetch(backend_url + "/delete-secret", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ secretToDelete, userId }),
      });
      if (!response.ok) {
        throw new Error("Failed to delete secret");
      }
      const data = await response.json();
      if (data.success) {
        await fetchSecrets();
      } else {
        alert(data.error);
      }
    } catch (error) {
      console.error("Error deleting secret:", error);
    }
  };

  const renderProfile = () => {
    return (
      <div
        style={{
          width: "90%",
          maxWidth: "500px",
          padding: "25px",
          paddingBottom: "25px",
          background: "rgba(255, 255, 255, 0.2)",
          backdropFilter: "blur(10px)",
          borderRadius: "10px",
          boxShadow: "0 8px 24px rgba(0, 0, 0, 0.15)",
          border: "2px solid rgba(255, 255, 255, 0.3)",
        }}
        className="mt-14 lg:mt-10 mb-14"
      >
        <h2
          style={{
            color: "var(--color-primary)",
            fontSize: "28px",
            fontWeight: "600",
            marginBottom: "25px",
          }}
        >
          Update Profile
        </h2>
        {isLoadingProfile ? (
          <Spinner />
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "18px",
            }}
          >
            <TextField
              label="First Name"
              value={profile.firstName}
              onChange={(e) =>
                setProfile({ ...profile, firstName: e.target.value })
              }
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  "&:hover fieldset": {
                    borderColor: "var(--color-secondary)",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "var(--color-primary)",
                  },
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "var(--color-primary)",
                },
              }}
            />

            <TextField
              label="Last Name"
              value={profile.lastName}
              onChange={(e) =>
                setProfile({ ...profile, lastName: e.target.value })
              }
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  "&:hover fieldset": {
                    borderColor: "var(--color-secondary)",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "var(--color-primary)",
                  },
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "var(--color-primary)",
                },
              }}
            />
            <TextField
              label="Job Title"
              value={profile.jobTitle}
              onChange={(e) =>
                setProfile({ ...profile, jobTitle: e.target.value })
              }
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  "&:hover fieldset": {
                    borderColor: "var(--color-secondary)",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "var(--color-primary)",
                  },
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "var(--color-primary)",
                },
              }}
            />
            <TextField
              label="Company Name"
              value={profile.companyName}
              onChange={(e) =>
                setProfile({ ...profile, companyName: e.target.value })
              }
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  "&:hover fieldset": {
                    borderColor: "var(--color-secondary)",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "var(--color-primary)",
                  },
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "var(--color-primary)",
                },
              }}
            />
            <TextField
              label="Password"
              type="password"
              value={profile.password}
              onChange={(e) =>
                setProfile({ ...profile, password: e.target.value })
              }
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  "&:hover fieldset": {
                    borderColor: "var(--color-secondary)",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "var(--color-primary)",
                  },
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "var(--color-primary)",
                },
              }}
            />
            <TextField
              label="Confirm Password"
              type="password"
              value={profile.confirmPassword}
              onChange={(e) =>
                setProfile({ ...profile, confirmPassword: e.target.value })
              }
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  "&:hover fieldset": {
                    borderColor: "var(--color-secondary)",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "var(--color-primary)",
                  },
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "var(--color-primary)",
                },
              }}
            />
            <Button
              content="Update Profile"
              onClick={handleUpdateProfile}
              isLoading={isUpdatingProfile}
            />
          </div>
        )}
      </div>
    );
  };

  const renderSubscriptions = () => {
    return (
      <div
        style={{
          width: "90%",
          padding: "25px",
          paddingBottom: "45px",
          background: "rgba(255, 255, 255, 0.2)",
          backdropFilter: "blur(10px)",
          borderRadius: "10px",
          boxShadow: "0 8px 24px rgba(0, 0, 0, 0.15)",
          border: "2px solid rgba(255, 255, 255, 0.3)",
        }}
        className="mt-14 lg:mt-10 mb-14"
      >
        <h2
          style={{
            color: "var(--color-primary)",
            fontSize: "28px",
            fontWeight: "600",
          }}
        >
          Subscriptions
        </h2>

        <div className="px-2">
          <h3
            style={{
              color: "var(--color-primary)",
              fontSize: "16px",
              marginBottom: "10px",
            }}
          >
            Subscription Details
          </h3>
          <div
            style={{
              marginBottom: "20px",
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Select
              value={subscriptionType}
              onChange={(e) => setSubscriptionType(e.target.value)}
              className="w-full lg:w-1/3 transition-colors"
              variant="outlined"
              sx={{
                "&.MuiOutlinedInput-root, & .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "gray",
                  },
                  "&:hover fieldset": {
                    borderColor: "var(--color-primary)",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "var(--color-primary)",
                  },
                },
              }}
            >
              <MenuItem value="Standard">Standard</MenuItem>
              <MenuItem value="premium">premium</MenuItem>
              <MenuItem value="Professional">Professional</MenuItem>
            </Select>

            <TextField
              label="Number of Months"
              type="number"
              value={months}
              onChange={(e) => {
                setMonths(Math.max(1, parseInt(e.target.value) || 1));
              }}
              inputProps={{ min: 1 }}
              className="w-full lg:w-1/3 transition-colors"
              variant="outlined"
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "gray",
                  },
                  "&:hover fieldset": {
                    borderColor: "var(--color-primary)",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "var(--color-primary)",
                  },
                },
                "& .MuiInputLabel-root": {
                  color: "gray",
                  "&.Mui-focused": {
                    color: "var(--color-primary)",
                  },
                },
              }}
            />

            <div className="flex flex-col lg:flex-row items-start lg:items-center gap-2 w-full lg:w-auto">
              <div
                style={{
                  padding: "5px",
                  borderRadius: "4px",
                  backgroundColor: "#395692",
                  display: "flex",
                  flexDirection: "column",
                  fontSize: "15px",
                  fontWeight: "600",
                  color: "white",
                  animation: "pulse 1.2s ease-in-out infinite",
                }}
              >
                <p>Amount: €{amount}</p>
                <p>Tokens: {Number(tokens / 1000).toLocaleString("en-US")}</p>
              </div>

              <style>
                {`
@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}
`}
              </style>
            </div>
            <Button
              content="Subscribe"
              onClick={handleGeneratePayment}
              className={"w-full lg:w-36 h-10 lg:h-14 "}
              style={{ borderRadius: "4px", fontSize: "18px" }}
            />
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "start",
              alignItems: "center",
              gap: "10px",
              flexWrap: "wrap",
              marginBottom: "20px",
            }}
          >
            <h3
              style={{
                color: "var(--color-primary)",
                fontSize: "16px",
                marginTop: "1px",
              }}
            >
              Subscription History
            </h3>
            <button
              onClick={() => fetchSubscriptions()}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "6px",
                padding: "5px 8px",
                background:
                  "linear-gradient(135deg, #452ad1, #715dda, #3edfd0)",
                color: "#ffffff",
                fontSize: "12px",
                fontWeight: "500",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
              }}
            >
              <FiRefreshCcw />
              Refresh
            </button>
          </div>

          {isSubscriptionsLoading ? (
            <Spinner />
          ) : (
            <div className="w-full overflow-x-auto">
              <table className="w-full border-collapse text-center text-sm text-gray-600 rounded-2xl overflow-hidden shadow-lg">
                <thead>
                  <tr
                    style={{
                      background:
                        "linear-gradient(to right, #452ad1, #715dda, #3edfd0)",
                      color: "white",
                    }}
                  >
                    <th className="p-3 border border-gray-200 font-bold">
                      Type
                    </th>
                    <th className="p-3 border border-gray-200 font-bold hidden lg:table-cell">
                      Start Date
                    </th>
                    <th className="p-3 border border-gray-200 font-bold hidden lg:table-cell">
                      Expiry Date
                    </th>
                    <th className="p-3 border border-gray-200 font-bold hidden lg:table-cell">
                      Tokens
                    </th>
                    <th className="p-3 border border-gray-200 font-bold hidden lg:table-cell">
                      Amount (€)
                    </th>
                    <th className="p-3 border border-gray-200 font-bold lg:hidden"></th>
                  </tr>
                </thead>
                <tbody>
                  {subscriptions.map((sub, index) => (
                    <tr
                      key={index}
                      className="transition-all"
                      style={{ backgroundColor: "white", color: "black" }}
                    >
                      <td className="p-3 border border-gray-200">{sub.type}</td>
                      <td className="p-3 border border-gray-200 hidden lg:table-cell">
                        {sub.startDate}
                      </td>
                      <td className="p-3 border border-gray-200 hidden lg:table-cell">
                        {sub.expiryDate}
                      </td>
                      <td className="p-3 border border-gray-200 hidden lg:table-cell">
                        {sub.tokens / 1000}
                      </td>
                      <td className="p-3 border border-gray-200 hidden lg:table-cell">
                        {sub.amount}
                      </td>

                      <td className="p-3 border border-gray-200 lg:hidden">
                        <button
                          onClick={() => setSelectedSub(sub)}
                          className="rounded-md text-white px-1 py-1 text-xs font-medium shadow-md transition-all"
                          style={{
                            background:
                              "linear-gradient(to right, #452ad1, #715dda, #3edfd0)",
                          }}
                        >
                          See More
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    );
  };

  const renderSecrets = () => {
    return (
      <div
        style={{
          width: "90%",
          padding: "25px",
          paddingBottom: "45px",
          background: "rgba(255, 255, 255, 0.2)",
          backdropFilter: "blur(10px)",
          borderRadius: "10px",
          boxShadow: "0 8px 24px rgba(0, 0, 0, 0.15)",
          border: "2px solid rgba(255, 255, 255, 0.3)",
        }}
        className="mt-14 lg:mt-10 mb-14"
      >
        <h2
          style={{
            color: "var(--color-primary)",
            fontSize: "28px",
            fontWeight: "600",
            marginBottom: "25px",
          }}
        >
          Secrets Management
        </h2>

        <div className="px-2">
          {/* Upper Section: Add Secret Form (Aligned in One Line) */}
          <h3
            style={{
              color: "var(--color-primary)",
              fontSize: "16px",
              marginBottom: "10px",
            }}
          >
            Add New Secret
          </h3>
          <div
            style={{
              marginBottom: "20px",
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Select
              value={platformType}
              onChange={(e) => setPlatformType(e.target.value)}
              className="w-full lg:w-1/4 transition-colors"
              variant="outlined"
              sx={{
                "&.MuiOutlinedInput-root, & .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "gray",
                  },
                  "&:hover fieldset": {
                    borderColor: "var(--color-primary)",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "var(--color-primary)",
                  },
                },
              }}
            >
              <MenuItem value="Fivetran">Fivetran</MenuItem>
              <MenuItem value="HVR6">HVR6</MenuItem>
              <MenuItem value="dbt labs">dbt labs</MenuItem>
              <MenuItem value="Informatica">Informatica</MenuItem>
              <MenuItem value="Airbyte">Airbyte</MenuItem>
            </Select>
            <TextField
              label="Secret Name"
              value={secretName}
              onChange={(e) => setSecretName(e.target.value)}
              className="w-full lg:w-1/4 transition-colors"
              variant="outlined"
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "gray",
                  },
                  "&:hover fieldset": {
                    borderColor: "var(--color-primary)",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "var(--color-primary)",
                  },
                },
                "& .MuiInputLabel-root": {
                  color: "gray",
                  "&.Mui-focused": {
                    color: "var(--color-primary)",
                  },
                },
              }}
            />
            <TextField
              label="Secret Value"
              value={secretValue}
              onChange={(e) => setSecretValue(e.target.value)}
              className="w-full lg:w-1/4 transition-colors"
              variant="outlined"
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "gray",
                  },
                  "&:hover fieldset": {
                    borderColor: "var(--color-primary)",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "var(--color-primary)",
                  },
                },
                "& .MuiInputLabel-root": {
                  color: "gray",
                  "&.Mui-focused": {
                    color: "var(--color-primary)",
                  },
                },
              }}
            />
            <Button
              content="Save Secret"
              onClick={handleSaveSecret}
              className={"w-full lg:w-36 h-10 lg:h-14"}
              style={{ borderRadius: "4px", fontSize: "18px" }}
              isLoading={isSavingSecretLoading}
            />
          </div>

          {/* Lower Section: Secrets Table (Scrollable) */}
          <div
            style={{
              display: "flex",
              justifyContent: "start",
              alignItems: "center",
              gap: "10px",
              flexWrap: "wrap",
              marginBottom: "20px",
            }}
          >
            <h3
              style={{
                color: "var(--color-primary)",
                fontSize: "16px",
                marginTop: "1px",
              }}
            >
              All Secrets
            </h3>
            <button
              onClick={() => fetchSecrets()}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "5px",
                padding: "4px 7px",
                background:
                  "linear-gradient(135deg, #452ad1, #715dda, #3edfd0)",
                color: "#ffffff",
                fontSize: "12px",
                fontWeight: "500",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
              }}
            >
              <FiRefreshCcw />
              Refresh
            </button>
          </div>

          {isLoadingSecrets ? (
            <Spinner />
          ) : (
            <div className="w-full overflow-x-auto">
              <table className="w-full border-collapse text-center text-sm text-gray-600 rounded-2xl overflow-hidden shadow-lg">
                <thead>
                  <tr
                    style={{
                      background:
                        "linear-gradient(to right, #452ad1, #715dda, #3edfd0)",
                      color: "white",
                    }}
                  >
                    <th className="p-3 border border-gray-200 font-bold">
                      Platform
                    </th>
                    <th className="p-3 border border-gray-200 font-bold hidden lg:table-cell">
                      Secret Name
                    </th>
                    <th className="p-3 border border-gray-200 font-bold hidden lg:table-cell">
                      Secret Value
                    </th>
                    <th className="p-3 border border-gray-200 font-bold">
                      Action
                    </th>
                    <th className="p-3 border border-gray-200 font-bold table-cell lg:hidden"></th>
                  </tr>
                </thead>
                <tbody>
                  {secrets.length > 0 ? (
                    secrets.map((secret, index) => (
                      <tr
                        key={index}
                        className="transition-all"
                        style={{ backgroundColor: "white", color: "black" }}
                      >
                        <td className="p-1 border border-gray-200">
                          {secret.platformType}
                        </td>
                        <td className="p-1 border border-gray-200 hidden lg:table-cell">
                          {secret.secretName}
                        </td>
                        <td className="p-1 border border-gray-200 hidden lg:table-cell">
                          {secret.secretValue.slice(0, 4) +
                            "*".repeat(
                              Math.max(0, secret.secretValue.length - 4),
                            )}
                        </td>
                        <td className="p-1 border border-gray-200">
                          <IconButton
                            color="error"
                            onClick={() => handleDeleteSecret(index)}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </td>

                        {
                          <td className="p-3 border border-gray-200 lg:hidden">
                            <button
                              onClick={() => setSelectedSec(secret)}
                              className="rounded-md text-white px-1 py-1 text-xs font-medium shadow-md transition-all"
                              style={{
                                background:
                                  "linear-gradient(to right, #452ad1, #715dda, #3edfd0)",
                              }}
                            >
                              See More
                            </button>
                          </td>
                        }
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="4"
                        style={{ padding: "10px", border: "1px solid #ddd" }}
                      >
                        No secrets available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    );
  };

  const messagesEndRef = useRef(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messagesFive, messagesH, messagesD, messagesAirbyte]);

  const renderChatMessages = () => {
    return (
      <div
        style={{
          flex: "1",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          paddingBottom: "20px",
        }}
        className="lg:pl-10"
      >
        {(
          {
            chatFive: {
              messages: messagesFive,
              processing: newIsProcessingFive,
            },
            chatH: { messages: messagesH, processing: newIsProcessingH },
            chatInformatica: {
              messages: messagesInformatica,
              processing: newIsProcessingInformatica,
            },
            chatD: { messages: messagesD, processing: newIsProcessingD },
            chatAirbyte: {
              messages: messagesAirbyte,
              processing: newIsProcessingAirbyte,
            },
          }[activeView] || { messages: [], processing: false }
        ).messages.map((msg, index, allMsgs) => (
          <div key={index} style={{ display: "contents" }}>
            {" "}
            {!(msg.role === "assistant" && msg.content.length === 0) && (
              <>
                {msg.fileName && (
                  <div
                    style={{ fontSize: "12px", color: "#555" }}
                    className="flex justify-end items-center gap-1"
                  >
                    <GrAttachment size={14} />
                    {msg.fileName.length > 16
                      ? `${msg.fileName.slice(0, 11)} ... ${msg.fileName.slice(-5)}`
                      : msg.fileName}
                  </div>
                )}
                <div
                  style={{
                    alignSelf: msg.role === "user" ? "flex-end" : "flex-start",
                    maxWidth: "80%",
                    position: "relative",
                    marginBottom: "10px",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      width: "0",
                      height: "0",
                      borderTop: "8px solid transparent",
                      borderBottom: "8px solid transparent",
                      bottom: "-7px",
                      zIndex: 1,
                      ...(msg.role === "user"
                        ? {
                            right: 0,
                            borderRight: "16px solid hsl(250, 50%, 85%)",
                          }
                        : {
                            left: 0,
                            borderLeft: "16px solid rgb(226 226 226)",
                          }),
                    }}
                  />

                  <div
                    style={{
                      backgroundColor:
                        msg.role === "user"
                          ? "hsl(250, 50%, 85%)"
                          : "rgb(226 226 226)",
                      padding: "10px 15px",
                      borderRadius:
                        msg.role === "user"
                          ? "5px 5px 0px 5px"
                          : "5px 5px 5px 0px",
                      fontSize: "12px",
                      fontWeight: "600",
                      wordBreak: "break-word",
                      whiteSpace: "pre-wrap",

                      overflowX: "auto",
                      overflowY: "hidden",

                      display: "block",
                      position: "relative",
                      zIndex: 2,
                    }}
                  >
                    {msg.role === "assistant" ? (
                      <ReactMarkdown>{msg.content}</ReactMarkdown>
                    ) : (
                      msg.content
                    )}
                  </div>
                </div>
              </>
            )}
            {index === allMsgs.length - 1 &&
              {
                chatFive: newIsProcessingFive,
                chatH: newIsProcessingH,
                chatInformatica: newIsProcessingInformatica,
                chatD: newIsProcessingD,
                chatAirbyte: newIsProcessingAirbyte,
              }[activeView] && (
                <div
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    fontWeight: "bold",
                    fontSize: "12px",
                    color: "var(--color-primary)",
                    animation: "pulse 1.5s infinite",
                  }}
                >
                  Processing
                  {[0, 0.3, 0.6].map((delay) => (
                    <span
                      key={delay}
                      style={{
                        display: "inline-block",
                        width: "3px",
                        height: "3px",
                        backgroundColor: "var(--color-primary)",
                        borderRadius: "50%",
                        marginLeft: "2px",
                        animation: `bounce 1s ${delay}s infinite`,
                      }}
                    />
                  ))}
                  <style>{`
            @keyframes pulse { 0%, 100% { opacity: 0.9; } 50% { opacity: 0.7 } }
            @keyframes bounce { 0%, 80%, 100% { transform: translateY(-1px); } 40% { transform: translateY(1px); } }
          `}</style>
                </div>
              )}
          </div>
        ))}

        {/* Add an invisible div at the end to scroll into view */}
        <div ref={messagesEndRef} />
        {isTyping && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              color: "gray",
              fontSize: "14px",
            }}
          >
            <CircularProgress size={20} />
            <span>Typing...</span>
          </div>
        )}
      </div>
    );
  };

  const renderChatInput = () => {
    return (
      <>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            padding: "15px 15px 15px 15px",
            boxSizing: "border-box",
            position: "sticky",
            zIndex: "2",
            bottom: 0,
            left: "-20px",
            overflowX: "hidden",
            backgroundImage: "url(/stay.png)",
            backgroundSize: "cover",
            borderRadius: "10px 10px 0 0",
            boxShadow: "0 8px 24px rgba(122, 21, 21, 0.15)",
            border: "2px solid rgba(255, 255, 255, 0.3)",
          }}
        >
          <SelectedFilePreview />
          <UploadButton platform={platform} />

          <TextareaAutosize
            type="text"
            placeholder="ASK ANYTHING"
            value={input}
            maxRows={4}
            onChange={(e) => {
              const value = e.target.value;

              if (value.length > 1000) {
                setInput(value.slice(0, 1000));
                toast.error(
                  "Message too long! Maximum allowed is 1000 characters.",
                );
                return;
              }

              setInput(value);
            }}
            onPaste={(e) => {
              e.preventDefault();

              const pastedText = e.clipboardData.getData("text");
              const newValue = (input + pastedText).slice(0, 1000);

              if (input.length + pastedText.length > 1000) {
                toast.error(
                  "Message too long! Maximum allowed is 1000 characters.",
                );
              }

              setInput(newValue);
            }}
            onKeyDown={handleKeyPress}
            style={{
              flex: "1",
              // padding: "12px 50px 12px 12px",
              padding: "12px 50px 12px 50px",
              paddingRight: selectedFile ? "280px" : "50px",
              fontSize: "16px",
              border: "1px solid gray",
              borderRadius: "5px",
              boxSizing: "border-box",
              background: "transparent",
              resize: "none",
              minWidth: "100%",
            }}
            onFocus={(e) => {
              e.target.style.outline = "none";
              e.target.style.borderColor = "var(--color-primary)";
            }}
            onBlur={(e) => {
              e.target.style.borderColor = "#ccc";
            }}
          />

          <div
            style={{
              position: "absolute",
              right: "65px",
              top: "50%",
              transform: "translateY(-50%)",
              height: "40px",
              width: "1px",
              backgroundColor: "#ccc",
            }}
          />

          <button
            onClick={handleSendMessage}
            style={{
              backgroundColor: "transparent",
              color: input.trim() ? "var(--color-primary)" : "#ccc",
              border: "none",
              cursor: input.trim() && !uploading ? "pointer" : "default",
              position: "absolute",
              right: "27px",
              top: "50%",
              transform: "translateY(-50%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "5px",
              transition: "color 0.3s ease",
            }}
          >
            {uploading ? (
              <Spinner />
            ) : (
              <SendIcon style={{ fontSize: "28px" }} />
            )}
          </button>
        </div>
      </>
    );
  };

  const scrollToBottom = () => {
    if (mainRef.current) {
      mainRef.current.scrollTo({
        top: mainRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [messagesH, messagesFive, messagesD, messagesAirbyte]);

  const renderChatView = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          borderRadius: "10px",
          position: "relative",
          minHeight: "100vh",
        }}
        className={!isDesktopSidebar ? "pt-28" : undefined}
      >
        <div
          style={{
            flexShrink: 0,
            boxSizing: "border-box",
            display: "flex",
            backgroundImage: "url(/chat.png)",
            backgroundSize: "cover",
            justifyContent: "flex-end",
            ...(isDesktopSidebar
              ? { position: "sticky", top: 0, zIndex: 10 }
              : {
                  position: "fixed",
                  top: 0,
                  left: 0,
                  right: 0,
                  zIndex: 10,
                }),
            // justifyContent: "space-between",
          }}
          className={`top-0 box-border border-b-2 border-gray-300 py-6 pl-5 xl:flex-row flex-col items-end gap-4 ${
            isDesktopSidebar ? "-ml-12 -mr-12 w-[calc(100%+6rem)]" : ""
          }`}
        >
          <div className="mr-16 lg:mr-20 flex gap-2.5 sm:gap-1 items-center flex-wrap-reverse justify-end">
            {/*<span
              style={{
                marginRight: "20px",
                backgroundColor: "green",
                color: "white",
                padding: "3px 9px",
                borderRadius: "6px",
                fontSize: "13px",
                fontWeight: "600",
              }}
            >
              {platform}
            </span>*/}

            <div className="flex w-full sm:w-auto items-center justify-end gap-1">
              {activeSubscription === "No Active Subscription" ? null : (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "2px",
                  }}
                  className="inline"
                >
                  <img src="/token.png" alt="token" />
                  <span
                    style={{
                      color: "var(--color-primary)",
                      fontSize: "14px",
                      fontWeight: "600",
                    }}
                  >
                    Credits
                  </span>
                </div>
              )}

              {isLoadingTokens === "loading for the first time" ? (
                <Spinner />
              ) : (
                <div
                  style={{
                    backgroundColor: "#395692",
                    borderRadius: "6px",
                    fontSize: "13px",
                    color: "white",
                    fontWeight: "600",
                    padding: "4px 6px",
                  }}
                >
                  {newFetchedTokens?.remaining === null ? (
                    "Not available right now!"
                  ) : newFetchedTokens?.remaining === 0 &&
                    newFetchedTokens?.total === 0 ? (
                    "No Active Subscription"
                  ) : (
                    <p>
                      {Math.ceil((newFetchedTokens?.remaining || 0) / 1000)} /{" "}
                      {newFetchedTokens?.total / 1000}
                    </p>
                  )}
                </div>
              )}
            </div>

            <FileManager userId={userId} selectedPlatform={platform} />
          </div>
        </div>
        <div
          style={{
            flex: "1",
            minHeight: 0,
            overflowY: "auto",
            scrollbarWidth: "thin",
            scrollbarColor: "var(--color-secondary) #f0f0f0",
            paddingTop: "20px",
          }}
        >
          {renderChatMessages()}
        </div>

        {renderChatInput()}
      </div>
    );
  };

  const renderContent = () => {
    if (
      activeView === "chatFive" ||
      activeView === "chatH" ||
      activeView === "chatInformatica" ||
      activeView === "chatD" ||
      activeView === "chatAirbyte"
    ) {
      return renderChatView();
    } else if (activeView === "subscriptions") {
      return renderSubscriptions();
    } else if (activeView === "secrets") {
      return renderSecrets();
    } else if (activeView === "profile") {
      return renderProfile();
    }
    return null;
  };

  const RestDrawer = () => {
    const navigate = useNavigate();

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          zIndex: "40",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            padding: "10px",
            gap: "10px",
            marginBottom: "20px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "10px",
              justifyContent: "space-between",
              width: "100%",
              cursor: "pointer",
            }}
          >
            <img
              src="/logo4.svg"
              alt="Datagenx Logo"
              onClick={() => navigate("/")}
            />
          </div>
        </div>

        <List>
          <ListItem
            style={{
              padding: "0",
              paddingLeft: "10px",
              paddingBottom: isMobileDrawerOpen ? "8px" : "0",
            }}
          >
            <ListItemIcon style={{ minWidth: "30px", marginRight: "0" }}>
              <img
                src="/chat2.png"
                alt="chat"
                style={{ width: "20px", height: "20px" }}
              />
            </ListItemIcon>
            <ListItemText
              primary="Agentic"
              style={{
                color: "rgba(132, 132, 132, 1)",
                fontSize: "14px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            />
          </ListItem>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              paddingLeft: "40px",
              fontSize: "13px",
              gap: "2px",
            }}
          >
            <>
              <style>
                {`
      .platform-item {
        padding: 5px 8px;
        cursor: pointer;
        border-radius: 6px;
        width: 180px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        transition: background 0.2s ease;
      }

      .platform-item:not(.active):hover {
        background: linear-gradient(
          135deg,
          rgba(69, 42, 209, 0.2),
          rgba(113, 93, 218, 0.2),
          rgba(62, 223, 208, 0.2)
        );
        font-weight: 500;
      }

      .platform-item.active {
        background: linear-gradient(135deg, #452ad1, #715dda, #3edfd0);
        color: white;
        font-weight: 600;
      }

      .platform-item:not(.active) {
        color: rgba(132, 132, 132, 1);
        font-weight: 400;
      }

      .preview-badge {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        background-color: #452ad1;
        color: #ffffff;
        padding: 3px 3.5px 2px 3.5px;
        border-radius: 4px;
        font-size: 8px;
        font-weight: 600;
        line-height: 1;
        white-space: nowrap;
        margin-left: 8px;
        flex-shrink: 0;
      }
    `}
              </style>

              {/*["Fivetran", "HVR5", "HVR6"].map((p, i) => (*/}
              {copilotPlatforms.map(({ label, showPreview }, i) => (
                <span
                  key={label}
                  onClick={() => handleClickPlatform(label)}
                  className={`platform-item ${platform === label ? "active" : ""}`}
                  style={{
                    marginBottom:
                      i === copilotPlatforms.length - 1 ? "6px" : "0",
                  }}
                >
                  <span
                    style={{
                      flex: "1",
                      minWidth: 0,
                    }}
                  >
                    {label}
                  </span>
                  {showPreview && (
                    <span className="preview-badge">Preview</span>
                  )}
                </span>
              ))}
            </>
          </div>

          <ListItem
            button
            onClick={() => {
              setActiveView("subscriptions");
              handleDrawerClose();
            }}
            style={{
              padding: "0",
              paddingLeft: "10px",
              paddingBottom: isMobileDrawerOpen ? "8px" : "0",
            }}
          >
            <ListItemIcon style={{ minWidth: "30px", marginRight: "0" }}>
              <img
                src="/subscriptions.png"
                alt="subscriptions"
                style={{ width: "20px", height: "20px" }}
              />
            </ListItemIcon>
            <ListItemText
              primary="Subscriptions"
              style={{
                color: "rgba(132, 132, 132, 1)",
                fontSize: "14px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            />
          </ListItem>
          <ListItem
            button
            onClick={() => {
              setActiveView("secrets");
              handleDrawerClose();
            }}
            style={{
              padding: "0",
              paddingLeft: "10px",
              paddingBottom: isMobileDrawerOpen ? "8px" : "0",
            }}
          >
            <ListItemIcon style={{ minWidth: "30px", marginRight: "0" }}>
              <img
                src="/secrets.png"
                alt="secrets"
                style={{ width: "20px", height: "20px" }}
              />
            </ListItemIcon>
            <ListItemText
              primary="Secrets"
              style={{
                color: "rgba(132, 132, 132, 1)",
                fontSize: "14px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            />
          </ListItem>
          <ListItem
            button
            onClick={() => {
              setActiveView("profile");
              handleDrawerClose();
            }}
            style={{
              padding: "0",
              paddingLeft: "10px",
              paddingBottom: isMobileDrawerOpen ? "8px" : "0",
            }}
          >
            <ListItemIcon
              style={{
                minWidth: "30px",
                marginRight: "0",
                marginBottom: "2px",
                opacity: "0.6",
              }}
            >
              <CgProfile style={{ fontSize: "20px" }} />
            </ListItemIcon>
            <ListItemText
              primary="Update Profile"
              style={{
                color: "rgba(132, 132, 132, 1)",
                fontSize: "14px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            />
          </ListItem>
          {/*<ListItem
            button
            style={{
              padding: "0",
              paddingLeft: "10px",
              paddingBottom: isMobileDrawerOpen ? "8px" : "0",
            }}
            onClick={() => {
              handleDrawerClose();
            }}
          >
            <ListItemIcon style={{ minWidth: "30px", marginRight: "0" }}>
              <img
                src="/history.png"
                alt="history"
                style={{ width: "20px", height: "20px" }}
              />
            </ListItemIcon>
            {/*<ListItemText
              primary="Chat History"
              style={{
                color: "rgba(132, 132, 132, 1)",
                fontSize: "14px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            />
          </ListItem>*/}

          <ListItem
            button
            style={{
              padding: "0",
              paddingLeft: "10px",
              paddingBottom: isMobileDrawerOpen ? "8px" : "0",
            }}
            onClick={() => {
              handleDrawerClose();
            }}
          >
            <ListItemIcon
              style={{
                minWidth: "30px",
                marginRight: "0",
                marginBottom: "2px",
                opacity: "0.6",
              }}
            >
              <MdHelpOutline style={{ fontSize: "20px" }} />
            </ListItemIcon>
            <ListItemText
              primary="Help"
              style={{
                color: "rgba(132, 132, 132, 1)",
                fontSize: "14px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            />
          </ListItem>
          <ListItem
            button
            onClick={() => {
              handleReset();
            }}
            style={{
              padding: "0 10px",
              color: "#f44336",
            }}
          >
            <ListItemIcon
              style={{
                minWidth: "30px",
                marginBottom: "0",
                color: "#f44336",
              }}
            >
              {isLoadingReset ? (
                <CircularProgress size={16} style={{ color: "#fff" }} />
              ) : (
                <MdRestartAlt style={{ fontSize: "20px" }} />
              )}
            </ListItemIcon>
            <ListItemText
              primary={isLoadingReset ? "Reseting..." : "Reset Chat"}
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            />
          </ListItem>
          {/*<ListItem
            button
            style={{ padding: "0", paddingLeft: "10px" }}
            onClick={() => {
              handleDrawerClose();
            }}
          >
            <ListItemIcon style={{ minWidth: "30px", marginRight: "0" }}>
              <img
                src="/back.png"
                alt="back"
                style={{ width: "20px", height: "20px" }}
              />
            </ListItemIcon>
            <ListItemText
              primary="Back To Home"
              style={{
                color: "rgba(75, 75, 75, 1)",
                fontSize: "14px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
              onClick={() => navigate("/")}
            />
          </ListItem>*/}
        </List>
      </div>
    );
  };

  const toggleMobileDrawer = () => {
    setIsMobileDrawerOpen(!isMobileDrawerOpen);
    setLogOutOpened(false);
  };

  const handleDrawerClose = () => {
    setIsMobileDrawerOpen(false);
  };

  const [showButton, setShowButton] = useState(true);
  useEffect(() => {
    const handleScroll = () => {
      if (!mainRef.current) return;
      const scrollTop = mainRef.current.scrollTop;
      if (scrollTop > 10) {
        setShowButton(false);
      } else {
        setShowButton(true);
      }
    };

    const mainEl = mainRef.current;
    mainEl.addEventListener("scroll", handleScroll);

    return () => mainEl.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      style={{
        display: "flex",
        height: "100vh",
        backgroundImage: "url(/chat.png)",
        backgroundSize: "cover",
        position: "relative",
      }}
    >
      {showButton && (
        <div
          className="lg:hidden absolute right-4 z-50"
          style={{ top: "24px", right: "24px" }}
        >
          <IconButton
            onClick={toggleMobileDrawer}
            style={{
              backgroundColor: "var(--color-secondary)",
            }}
          >
            {isMobileDrawerOpen ? (
              <FiX size={17} color={"white"} />
            ) : (
              <FiMenu size={17} color={"white"} />
            )}
          </IconButton>
        </div>
      )}

      {isMobileDrawerOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-30 cursor-pointer"
          onClick={handleDrawerClose}
        />
      )}

      <div
        className="hidden lg:flex lg:flex-col justify-between"
        style={{ borderRight: "2px solid rgba(209, 213, 219)" }}
      >
        <Drawer
          variant="permanent"
          anchor="left"
          style={{
            transition: "width 0.3s ease",
            overflow: "hidden",
          }}
          PaperProps={{
            style: {
              backgroundColor: "transparent",
              boxShadow: "none",
              border: "none",
              position: "relative",
            },
          }}
          className="hidden lg:block pl-10 pr-14 pt-2 pb-4"
        >
          {RestDrawer()}
        </Drawer>
        <div
          style={{
            borderTop: "2px solid rgba(209, 213, 219)",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            paddingTop: "16px",
            paddingBottom: "16px",
            position: "relative",
            paddingLeft: "50px",
            paddingRight: "14px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Avatar
              onClick={() => setLogOutOpened((prev) => !prev)}
              sx={{ width: 35, height: 35, cursor: "pointer" }}
            >
              {userName.charAt(0)}
            </Avatar>
            <div>
              <div
                style={{
                  color: "rgba(254, 163, 25, 1)",
                  fontSize: "16px",
                  fontWeight: "bold",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {userName}
              </div>
              <div
                style={{
                  fontSize: "11px",
                  fontWeight: "600",
                  color:
                    activeSubscription === "No Active Subscription"
                      ? "red"
                      : "var(--color-primary)",
                }}
              >
                {activeSubscription === "No Active Subscription"
                  ? "No Active Subscription"
                  : activeSubscription}
              </div>
            </div>
          </div>

          <div
            onClick={onLogout}
            style={{
              display: logOutOpened ? "flex" : "none",
              alignItems: "center",
              gap: "5px",
              cursor: "pointer",
              padding: "6px 10px",
              backgroundColor: "#fff",
              position: "absolute",
              top: "-20px",
              left: "50px",
              borderRadius: "12px",
              fontSize: "12px",
            }}
          >
            <div
              style={{
                position: "absolute",
                bottom: "-4px",
                left: "30%",
                transform: "translateX(-50%)",
                width: 0,
                height: 0,
                borderLeft: "5px solid transparent",
                borderRight: "5px solid transparent",
                borderTop: "5px solid white",
              }}
            ></div>

            <LogoutIcon style={{ color: "red", fontSize: "14px" }} />
            <span style={{ color: "red", fontSize: "12px" }}>Logout</span>
          </div>
        </div>
      </div>

      <Drawer
        anchor="left"
        open={isMobileDrawerOpen}
        onClose={handleDrawerClose}
        style={{
          zIndex: 40,
        }}
        PaperProps={{
          style: {
            backgroundColor: "white",
            width: "80vw",
            maxWidth: "280px",
            paddingLeft: "20px",
            paddingRight: "28px",
            paddingTop: "8px",
            paddingBottom: "16px",
          },
        }}
        className="lg:hidden"
      >
        {RestDrawer()}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            paddingTop: "16px",
            paddingBottom: "16px",
            position: "relative",
            paddingLeft: "10px",
            paddingRight: "8px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Avatar
              onClick={() => setLogOutOpened((prev) => !prev)}
              sx={{ width: 35, height: 35, cursor: "pointer" }}
            >
              {userName.charAt(0)}
            </Avatar>
            <div>
              <div
                style={{
                  color: "rgba(254, 163, 25, 1)",
                  fontSize: "16px",
                  fontWeight: "bold",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {userName}
              </div>
              <div
                style={{
                  fontSize: "11px",
                  fontWeight: "600",
                  color:
                    activeSubscription === "No Active Subscription"
                      ? "red"
                      : "var(--color-primary)",
                }}
              >
                {activeSubscription === "No Active Subscription"
                  ? "No Active Subscription"
                  : activeSubscription}
              </div>
            </div>
          </div>

          <div
            onClick={onLogout}
            style={{
              display: logOutOpened ? "flex" : "none",
              alignItems: "center",
              gap: "5px",
              cursor: "pointer",
              padding: "8px 16px",
              background: "red",
              position: "absolute",
              top: "-30px",
              left: "12px",
              borderRadius: "12px",
            }}
          >
            <div
              style={{
                position: "absolute",
                bottom: "-6px",
                left: "20%",
                transform: "translateX(-50%)",
                width: 0,
                height: 0,
                borderLeft: "8px solid transparent",
                borderRight: "8px solid transparent",
                borderTop: "8px solid red",
              }}
            ></div>

            <LogoutIcon style={{ color: "white", fontSize: "14px" }} />
            <span style={{ color: "white", fontSize: "14px" }}>Logout</span>
          </div>
        </div>
      </Drawer>

      <main
        ref={mainRef}
        className={`
          flex-1 overflow-y-auto bg-transparent
          lg:pl-12 lg:pr-12
        `}
      >
        <div className="hidden lg:block">{renderContent()}</div>
        <div className="lg:hidden w-full min-w-0 px-4 md:px-6">
          {renderContent()}
        </div>

        {selectedSub && (
          <div
            className="fixed inset-0 flex items-center justify-center cursor-pointer"
            style={{
              backgroundColor: "rgba(0, 0, 0, 0.7)",
              backdropFilter: "blur(3px)",
              WebkitBackdropFilter: "blur(3px)",
              zIndex: "50",
            }}
          >
            <div
              className="relative w-2/3 max-w-md rounded-2xl p-6 text-center text-white shadow-2xl"
              style={{
                background:
                  "linear-gradient(135deg, #452ad1, #715dda, #3edfd0)",
              }}
            >
              <button
                onClick={() => setSelectedSub(null)}
                className="absolute top-3 right-3 text-white text-lg font-bold hover:text-gray-200"
              >
                ✕
              </button>
              <div className="space-y-2 text-sm">
                <p>
                  <span className="font-semibold">Type:</span>{" "}
                  {selectedSub.type}
                </p>
                <p>
                  <span className="font-semibold">Start Date:</span>{" "}
                  {selectedSub.startDate}
                </p>
                <p>
                  <span className="font-semibold">Expiry Date:</span>{" "}
                  {selectedSub.expiryDate}
                </p>
                <p>
                  <span className="font-semibold">Tokens:</span>{" "}
                  {selectedSub.tokens}
                </p>
                <p>
                  <span className="font-semibold">Amount (€):</span>{" "}
                  {selectedSub.amount}
                </p>
              </div>
            </div>
          </div>
        )}

        {selectedSec && (
          <div
            className="fixed inset-0 flex items-center justify-center cursor-pointer"
            style={{
              backgroundColor: "rgba(0, 0, 0, 0.7)",
              backdropFilter: "blur(3px)",
              WebkitBackdropFilter: "blur(3px)",
              zIndex: "50",
            }}
          >
            <div
              className="relative w-2/3 max-w-md rounded-2xl p-6 text-center text-white shadow-2xl"
              style={{
                background:
                  "linear-gradient(135deg, #452ad1, #715dda, #3edfd0)",
              }}
            >
              <button
                onClick={() => setSelectedSec(null)}
                className="absolute top-3 right-3 text-white text-lg font-bold hover:text-gray-200"
              >
                ✕
              </button>
              <div className="space-y-2 text-sm">
                <p>
                  <span className="font-semibold">Platform:</span>{" "}
                  {selectedSec.platformType}
                </p>
                <p>
                  <span className="font-semibold">Secret Name:</span>{" "}
                  {selectedSec.secretName}
                </p>
                <p>
                  <span className="font-semibold">Secret Value:</span>{" "}
                  {selectedSec.secretValue.slice(0, 4) +
                    "*".repeat(Math.max(0, selectedSec.secretValue.length - 4))}
                </p>
              </div>
            </div>
          </div>
        )}
      </main>
    </div>
  );
}

export default ChatbotPage;
